<script>
    import { api_host, hamburger_menu_open, user_store } from '../stores.js';
    import { createEventDispatcher } from 'svelte';
    import { getToken, doFetch } from '../utils/Fetching.js';
    import { push, querystring } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import { handle_not_subscribed, handle_unauthorized } from '../utils/format.js';


    let domain_name = '', plan_type = '';
    let myself = {};
    user_store.subscribe(value => {
        myself = value;
    });

    export let id = undefined;
    export let title = undefined;
    export let type = undefined;
    export let index = undefined;
    export let parent_index = undefined;
    export let open = false;
    export let menu_icon = "";
    export let has_subitems = false;
    export let is_sub_menu = false;
    export let show_item = true;
    export let hash_link = "";
    export let is_selected = false;
    export let menu_open_tracker = undefined;
    export let mobile_only = false;
    export let handle_directly = false;

	onMount(() => {
        const params = new URLSearchParams($querystring);
        if (params.has('domain_name')) {
            domain_name = params.get('domain_name');
        }
        if (params.has('plan_type')) {
            plan_type = params.get('plan_type');
        }
    });

    const dispatch = createEventDispatcher();

    async function doAction(open_type='on_tab') {
        // if (!myself.is_authenticated && id !== 'content') {
        //     handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
        // }
        // if (!myself.is_authenticated) {
        //     push(`#/Contenthomepage/free?domain_name=${domain_name}`);
        //     return;
        // }

        // if (domain_name === 'sample' && id === 'content') {
        //     push(`#/Contenthomepage/free?plan_type=${plan_type}&domain_name=${domain_name}`);
        //     return;
        // }

        if (domain_name === 'sample') {
            handle_unauthorized(myself.is_authenticated);
            return;
        }

        if (title === 'Logout') {
            const { auth_type, auth_token } = getToken();
            const res = await doFetch(
                api_host + '/auth/logout',
                'POST',
                {},
                { Authorization: `${auth_type} ${auth_token}` }
            );
            localStorage.removeItem('HoyToKenTy');
            localStorage.removeItem('HoyToKenTo');
            window.location.href = '/';
            return;
        }
        if (title === 'Profile') {
            push(`#/User_Review?uid=${myself.id}`);
        }
        if (title === 'Help') {
            window.location.href = 'https://houseofyards.tawk.help/';
            return;
        }
        if (open_type === 'on_tab') {
            if (handle_directly) {
                $hamburger_menu_open = false;
                push(hash_link);
            } else {
                dispatch('menumessage', {type: type, index: index, parent_index: parent_index, hash_link: hash_link});
            }
        } else {
            if (hash_link.length > 0) {
                window.open(`#${hash_link}`, '_blank');
            }
        }
    }
    // class="menubutton {(is_selected && (!has_subitems || (domain_name === 'sample' && id === 'content'))) ? 'is_selected' : ''}"
</script>


{#if show_item}
<div class="menubuttonholder {(is_sub_menu) ? "subitem" : ""}  {(mobile_only) ? "mobile_only" : ""}">
    {#if !(title === 'Payment' && myself.role !== 'landscaper')}
    <button
        class="menubutton {((is_selected && !has_subitems)) ? 'is_selected' : ''}"
        on:click={(e) => { doAction(); }}
        on:mouseup={(e) => { if (e.button === 1) doAction('new_tab'); }}
    >
        <i class="{menu_icon} menuitemicon"></i>{title}
        {#if has_subitems}
            <i class="fas fa-caret-{ open ? "down" : "right"} menuindicator"></i>
        {/if}
    </button>
    {/if}
</div>
{/if}


<style>
    :global(.menubutton.is_selected) {
        background-color: green !important;
        color: white !important;
    }
    :global(.mobile_only) {
        display: none;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.mobile_only) {
            display: block;
        }
    }
</style>